import Helpers from '@helpers';
import * as React from 'react';
import { OverlayHelper, State } from './model';
import './style.css';

const overlayHelper: OverlayHelper = {};

class Overlay extends React.Component<{}, State> {
    constructor(props) {
        super(props);
        this.state = this.getInitialState();
    }

    public componentDidMount() {
        overlayHelper.showOverlay = () => {
            this.setState({
                visible: true
            });

            $('#site-container').addClass('blur');
            $('body').css('overflow', 'hidden');
        };

        overlayHelper.hideOverlay = () => {
            this.setState({
                visible: false
            });

            $('#site-container').removeClass('blur');
            $('body').css('overflow', 'auto');
        };
    }

    public render() {
        return (
            <div
                onClick={overlayHelper.onClick}
                style={{display: this.getDisplayStyle()}}
                className='modal-overlay'>
            </div>
        );
    }

    private getInitialState = (): State => ({
        visible: false
    })

    private getDisplayStyle = () => this.state.visible ? 'block' : 'none';
}

Helpers.ReactHelper.createReactElement('Overlay', Overlay);

export default overlayHelper;
